import { T } from '../domaine/libelles'
import { el, requis, vider } from './dom'

/*
  Confirmation de saisie.

  Ne bloque JAMAIS l'écran : on peut enchaîner dix « +1 » sans jamais attendre.
  Une nouvelle saisie remplace la précédente au lieu de s'empiler.
  Durée : 2,2 s, comme la DA.
*/

const DUREE = 2200

let minuteur: ReturnType<typeof setTimeout> | null = null

export function montrerToast(texte: string): void {
  const noeud = requis('toast')

  if (minuteur) clearTimeout(minuteur)

  vider(noeud)
  noeud.append(
    el('div', { class: 'toast__texte', text: texte }),
    el('div', { class: 'toast__etat', text: T.enregistre }),
  )
  noeud.hidden = false

  minuteur = setTimeout(() => {
    noeud.hidden = true
    minuteur = null
  }, DUREE)
}

export function masquerToast(): void {
  if (minuteur) clearTimeout(minuteur)
  minuteur = null
  requis('toast').hidden = true
}
